import React, { Component } from 'react';
import { connect } from 'react-redux';

import Logger, { LOG_LEVELS } from '../../../utils/logger';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import FilingFrequencySelector from '../../selectors/filing/FilingFrequencySelector';
import GlobalFilterPanel from '../../filter/GlobalFilterPanel';

const log = new Logger('RETURN_BY_TRANSACTIONS_FILTER_PANEL', LOG_LEVELS.DEBUG);
const DEFAULT_FILTER_SETTING= {
  fieldOptions: {},
  hideElements:  {
      startDate: true,
      endDate: true,
      countryCode: true,
      companyId: true
  }
};


export class returnByTransactionsFilterPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
        selection: {},
        filterSetting: DEFAULT_FILTER_SETTING
    };
    this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    this.onFrequencyChangeHandlerFactory = this.onFrequencyChangeHandlerFactory.bind(this);
}

  onSearchClickHandler(selection) {
    log.debug('onSearchClickHandler(): selection: ', selection);
    this.props.onSearch(this.state.selection)
  }

  transactionTypeInputHandler(evt) {
    let selection = Object.assign({}, this.state.selection, {transactionType: evt.target.value});
    log.debug('transactionTypeInputHandler: ', selection);
    this.setState({selection: selection});
  }

  fixedAssetsInputHandler(evt) {
    let selection = Object.assign({}, this.state.selection);
    selection.fixedAssets = (evt.target.checked) ? '1': '0';
    log.debug('fixedAssetsInputHandler: ', selection);
    this.setState({selection: selection});
  }

  onFrequencyChangeHandlerFactory(evt)
  {
      log.debug('onFrequencyChangeHandlerFactory Value', evt.target.value);
      let selection = Object.assign({}, this.state.selection);
      selection.frequency = evt.target.value;
      this.setState({ selection: selection});
  }

  render() {
    log.debug('render: ', this.props);
    const selection = this.state.selection;

    const globalFilterSetting = {
      hideElements: {
        countryCode: true,
        month: true,
        year: true,
        companyId: true,
        startDate: true,
        endDate: true,
        returnType: true,
        returnStatus: true
      },
      requiredFields: {
      },
      onSearchClick: this.onSearchClick,
      searchLabelLanguageString: 'globalFilterPanel_search',
    };

    return (
      <s-box name="filter-panel">
        <GlobalFilterPanel
          {...globalFilterSetting}
          onSearchClick={this.onSearchClickHandler}>
          <fieldset>
            <legend><LanguageStringResolver string="returnByTransactionsFilterPanel_TransactionType"/></legend>
            <br />
            <input
              type="radio"
              onChange={this.transactionTypeInputHandler.bind(this)}
              name="transactionType"
              className="mt10 radio"
              value="sales"
              checked={selection.transactionType==="sales"}
            />
            <label className="mt10 radio"><LanguageStringResolver string="returnByTransactionsFilterPanel_Sales"/></label>
            <input
              type="radio"
              onChange={this.transactionTypeInputHandler.bind(this)}
              name="transactionType"
              className="mt10 radio"
              value="purchases"
              checked={selection.transactionType==="purchases"}
            />
            <label className="mt10 radio"><LanguageStringResolver string="returnByTransactionsFilterPanel_Purchases"/></label>
          </fieldset>
          <fieldset>
            <legend><LanguageStringResolver string="returnByTransactionsFilterPanel_FixedAssets"/></legend>
            <br />
            <input 
              type="checkBox"
              onChange={this.fixedAssetsInputHandler.bind(this)}
              name="fixedAssets"
              className="mt10 checkbox"
              checked={selection.fixedAssets==="1"}
            />
            <label className="mt10 checkbox"><LanguageStringResolver string="returnByTransactionsFilterPanel_True"/></label>
         </fieldset>
          <FilingFrequencySelector
            value={this.state.selection.frequency || this.props.defaultFrequencyId}
            selectionHandler={((frequencySelected)=> {
              let selection = Object.assign({}, this.state.selection);
              selection.frequency = frequencySelected ? frequencySelected.id  : this.props.defaultFrequencyId;
              this.setState({selection: selection});
            })}
            validPeriodIds={this.props.availablePeriods}
            placeholderTextLanguageString={'returnByTransactionsFilterPanel_placeholderTextLanguageString'}
            inline={false}
            labelText={<LanguageStringResolver string="returnByTransactionsFilterPanel_Boxes"/>}
            showDefaultValue={true}
          />
        </GlobalFilterPanel>
        <div className="clear"></div>
      </s-box>
    )
  }
  componentDidMount(){
    let selection = Object.assign({}, this.state.selection)
    selection.transactionType = 'sales';
    this.setState({selection: selection})
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state, props);
  return {};
}


returnByTransactionsFilterPanel.defaultProps = {
  onSearch: () => {},
  availablePeriods: [],
  defaultFrequencyId: '0'
};

// Wrap the component to inject state into it
export default connect(mapStateToProps)(returnByTransactionsFilterPanel);
